import { useEffect, useState } from 'react'
import { Drawer, Form, Button } from 'antd'

import FormAdmin from './FormAdmin'

interface IProps {
  onSuccess: () => void
  onClose: () => void
  isOpen: boolean
  dataSource?: any
}
const AdminDrawer = ({ onSuccess, onClose, isOpen, dataSource }: IProps) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if (isOpen) {
      setLoading(false)
      if (dataSource?.id) {
        form.setFieldsValue(dataSource)
      }
    }
    return () => {
      isOpen && form.resetFields()
    }
  }, [isOpen])

  const onCancel = () => {
    form.resetFields()
    onClose()
  }

  const FooterDrawer = () => (
    <div className='flex justify-between text-right'>
      <div>
        <Button disabled={loading} onClick={onCancel} style={{ marginRight: 8 }}>
          Close
        </Button>
      </div>
      <div className='flex gap-2'>
        <Button loading={loading} type='primary' onClick={() => form.submit()}>
          Save
        </Button>
      </div>
    </div>
  )

  return (
    <Drawer
      title='Admin Profile'
      width={768}
      closable={false}
      maskClosable={false}
      onClose={onCancel}
      open={isOpen}
      bodyStyle={{ paddingBottom: 80 }}
      footer={<FooterDrawer />}
    >
      {!!isOpen && (
        <FormAdmin
          form={form}
          dataSource={dataSource}
          adminId={dataSource?.id}
          onSuccess={onSuccess}
        />
      )}
    </Drawer>
  )
}

export default AdminDrawer
